import { SxProps } from '@mui/system';
import useTheme from '@mui/system/useTheme';
import chroma from 'chroma-js';
import { useMemo } from 'react';

import { Box } from './Box';

interface DotProps {
  sx?: SxProps;
}

export const Dot: React.FC<DotProps> = ({ sx }) => {
  const theme = useTheme();

  const color = useMemo(() => {
    const [, saturation] = chroma(theme.palette.primary.main).hsl();
    // If chosen primary color has low saturation we use alert color
    const color = saturation < 0.2 ? 'alert.main' : 'primary.main';
    return color;
  }, [theme.palette.primary]);

  const styles = {
    width: 8,
    height: 8,
    bgcolor: color,
    borderRadius: 5,
    flexShrink: 0,
    display: 'inline-block',
  };

  return (
    <Box
      component="span"
      sx={[styles, ...(Array.isArray(sx) ? sx : [sx])]}
    ></Box>
  );
};
